// const qa = {
//   STRIPE_KEY: 'pk_test_eEFdSLDJw0GGaxN3KzprJrEq',
//   apiGateway: {
//     REGION: 'us-west-2',
//     URL: 'https://ijki4pt1ef.execute-api.us-west-2.amazonaws.com/dev',
//   },
//   cognito: {
//     REGION: 'us-west-2',
//     USER_POOL_ID: 'us-west-2_0lHp1ERUm',
//     APP_CLIENT_ID: '765mlt47gvnn616j8t62dfva62',
//     IDENTITY_POOL_ID: 'us-west-2:2feed2c2-697c-478c-8b95-2c9db7a252e4',
//   },
// };

const beta = {
  STRIPE_KEY: 'pk_live_isMRo060kMO3np4a9ubUEtiM', //change it to prod 'pk_test_eEFdSLDJw0GGaxN3KzprJrEq',
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://api.agentbuzz.com/app-v1/',
  },
  cognito: {
    REGION: 'us-west-2',
    USER_POOL_ID: 'us-west-2_ConduE2VO',
    APP_CLIENT_ID: '5q8qde38jq16l9s73g6kajrdu4',
    IDENTITY_POOL_ID: 'us-west-2:b2c32a2e-40da-43c8-8d55-3e2954709483',
  },
};

// const config = process.env.REACT_APP_STAGE === 'beta' ? beta : qa;
const config = beta;

export default {
  ...config,
};



// WEBPACK FOOTER //
// ./src/config.js